import { render, staticRenderFns } from "./ReturnWithCaptain.vue?vue&type=template&id=96cee07c&scoped=true"
import script from "./ReturnWithCaptain.vue?vue&type=script&lang=js"
export * from "./ReturnWithCaptain.vue?vue&type=script&lang=js"
import style0 from "./ReturnWithCaptain.vue?vue&type=style&index=0&id=96cee07c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96cee07c",
  null
  
)

export default component.exports